import React, {useCallback, useMemo, useState} from 'react';
import {useIntl} from 'react-intl';

import OrderModel from 'coreClasses/order/OrderModel';
import withSSRPage from 'coreComponents/withSSRPage';
import {usePageInit, useSetUI} from 'coreHooks';

import CustomerCareWidget from 'brandComponents/CustomerCareWidget';
import DateComponent from 'brandComponents/DateComponent';
import {EDateComponentType} from 'brandComponents/DateComponent/IDateComponent';
import Grid from 'brandComponents/Grid';
import OrderDetails from 'brandComponents/OrderDetails';
import OrderStatus from 'brandComponents/OrderStatus';

import messages from './messages';
import {TrackOrderForm} from './Subcomponents';

import styles from './TrackOrder.module.scss';

const TrackOrderContent = () => {
	usePageInit({
		route: 'TrackOrder',
		seo: {
			metadata: [{title: messages.trackOrderTitle, description: 'Track Order page'}],
			pageUrls: '/track-order',
		}
	});

	const intl = useIntl();
	const setUI = useSetUI();
	const [trackOrder, setTrackOrder] = useState<OrderModel>(null);
	const orderCreationDate = useMemo(() => {
		return trackOrder?.getOrderCreationDate();
	}, [trackOrder]);

	const onReturnOrderSelected = useCallback((order: OrderModel) => {
		setUI.setSelectedReturnOrder(
			order.getOrderNumber(),
			order.getBillingAddress().getPostalCode()
		);
	}, []);

	return (
		<Grid fluid classNames={styles['track-order']}>
			<Grid.Row>
				<Grid.Column classNames={styles['track-order__widgets']} sm={3}>
					<CustomerCareWidget isReversedWidget={true} />
				</Grid.Column>
				<Grid.Column sm={9}>
					{trackOrder ? (
						<div className={styles['track-order__details']}>
							<span className={styles['track-order__summary-line']}>
								{intl.formatMessage(messages.orderPlaced)}{' '}
								{orderCreationDate ? (
									<DateComponent
										value={orderCreationDate}
										dateType={EDateComponentType.DATE_SHORT}
										timeStyle={null}
									/>
								) : (
									'-'
								)}
							</span>
							<span className={styles['track-order__summary-line']}>
								<OrderStatus status={trackOrder?.getStatusToDisplay()} />
							</span>
							<span className={styles['track-order__summary-line']}>
								{intl.formatMessage(messages.orderNumber)} {trackOrder.getOrderNumber()}
							</span>
							<OrderDetails
								isTrackOrder
								order={trackOrder}
								isAccordion={false}
								onReturnOrderSelected={onReturnOrderSelected}
							/>
						</div>
					) : (
						<TrackOrderForm onOrderTracked={setTrackOrder} />
					)}
				</Grid.Column>
			</Grid.Row>
		</Grid>
	);
};

export default withSSRPage(TrackOrderContent, 'track-order');
